var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",attrs:{"id":_vm.parent}},[_c('select',{staticClass:"form-control select2",staticStyle:{"color":"black"},attrs:{"id":_vm.parent + 'child'}},[_c('option',{attrs:{"disabled":"","hidden":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b85db0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/SearchBar/Select2Wrapper.vue
// module id = null
// module chunks = 